import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment";

type ApqCore = {
  id: string;
  queryTitle: string;
  queryMessage: string;
  sendToOfqual: boolean;
  sendToCcea: boolean;
  closedByDisplayName: string;
  closedByUpn: string;
  closedDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  modifiedDate: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  assignedToUpn: string;
  assignedToDisplayName: string;
  orgId: number;
  status: ApqStatus;
  sourceCtr: string;
  organisationId: number;
  queryReferenceNumber: string;
  apprenticeshipStandardId: number;
  assessmentPlanVersion: number;
  classificationId: number;
  orgName: string;
  queryFlag: ApqFlag[];
  resourceTags: number[];
  apqAttachments: Attachment[];
  files: File[];
  ofqualOnlyFiles: File[];
};

//Ofqual fields
type ApqOfqual = {
  //Engagement activity
  engagementActivityId: number;
  contactTypeId: number;
  engagementActivityDescription: string;

  //Assessment plan recommendatations
  shortTermSolution: string;
  longTermSolution: string;

  //EPAO actions & recommendations
  typeId: number;
  priorityId: number;
  areaForImprovementId: number;
  longDescription: string;
  fitForPurposeCriteriaId: number

  closedByDisplayName: string;
  closedByUpn: string;
  apqAttachmentsOfqual: Attachment[];
  ofqualOnlyFiles: File[];

  stakeholderType: number;
  nonAoOrgName: string;
};

export type ApqModel = ApqCore & ApqOfqual;

export const fromApiModel = (model: Model): ApqModel => {
  return {
    ...model,
  } as ApqModel;
};

export const toApiModel = (item: ApqModel): Model => {
  return {
    ...item,
  } as Model;
};

export enum ApqStatus {
  New = 0,
  Active = 1,
  Closed = 2,
}

export type ApqFlag = {
  id: number;
  queryId: number;
  flagId: number;
};

